var _stop, _stop2, _stop3, _stop4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgIconsColorShare(props) {
  const _id2 = useUniqueInlineId();
  const _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.608 27.3h29.234c1.43 0 2.608-1.163 2.608-2.575v-9.176a.838.838 0 00-.841-.83.838.838 0 00-.841.83v9.176c0 .498-.42.913-.926.913H2.608a.928.928 0 01-.926-.913V6.95c0-.498.42-.914.926-.914l9.302-.041a.838.838 0 00.841-.83.838.838 0 00-.84-.832H2.607C1.178 4.333 0 5.496 0 6.91v17.774A2.613 2.613 0 002.608 27.3z",
    fill: "url(#".concat(_id, ")"),
    transform: "translate(1.95 5.85)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.01 15.948c-.085.52.128 1.039.6 1.255.17.087.341.13.513.13.299 0 .641-.13.855-.39 3.21-3.766 9.541-3.895 11.766-3.809v2.944c0 .433.257.822.642 1.039.385.173.856.13 1.198-.173l9.113-7.706c.257-.216.428-.563.428-.909 0-.346-.171-.65-.428-.866L24.498.233A1.194 1.194 0 0023.3.104c-.385.174-.641.607-.641 1.04v3.073C12.09 6.381 9.566 13.134 9.01 15.948zm14.504-10.13c.514-.086.899-.563.899-1.125V2.355l7.616 6.017-7.616 6.364v-2.251c0-.606-.47-1.082-1.07-1.126-.3 0-.77-.043-1.412-.043-2.481 0-7.23.39-10.653 2.9 1.283-2.9 4.364-6.926 12.236-8.398z",
    fill: "url(#".concat(_id2, ")"),
    transform: "translate(1.95 5.85)"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "99.063%",
    x2: "50%",
    y2: "0%",
    id: _id
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#664FF9",
    offset: "0%"
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1253FA",
    offset: "100%"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "99.063%",
    x2: "50%",
    y2: "0%",
    id: _id2
  }, _stop3 || (_stop3 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#664FF9",
    offset: "0%"
  })), _stop4 || (_stop4 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1253FA",
    offset: "100%"
  })))));
}
export default SvgIconsColorShare;